import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Shield, ClipboardList, Users, CalendarCheck } from "lucide-react";
import EventCoverageTab from "@/components/admin/officials/EventCoverageTab";
import OfficialAssignmentsTab from "@/components/admin/officials/OfficialAssignmentsTab";
import OfficialRosterTab from "@/components/admin/officials/OfficialRosterTab";
import AvailabilityTab from "@/components/admin/officials/AvailabilityTab";

const EventManagementOfficials: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <Shield className="h-6 w-6 text-secondary" />
          Officials
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage the referee roster, assign officials to events, and track availability and pay.
        </p>
      </div>

      <Tabs defaultValue="coverage">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="coverage" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ClipboardList className="h-4 w-4" />
            <span className="hidden sm:inline">Event Coverage</span>
            <span className="sm:hidden">Coverage</span>
          </TabsTrigger>
          <TabsTrigger value="assignments" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <Users className="h-4 w-4" />
            <span className="hidden sm:inline">Assignments</span>
            <span className="sm:hidden">Assign</span>
          </TabsTrigger>
          <TabsTrigger value="roster" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <Shield className="h-4 w-4" />
            <span className="hidden sm:inline">Official Roster</span>
            <span className="sm:hidden">Roster</span>
          </TabsTrigger>
          <TabsTrigger value="availability" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <CalendarCheck className="h-4 w-4" />
            <span className="hidden sm:inline">Availability</span>
            <span className="sm:hidden">Avail</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="coverage" className="mt-6">
          <EventCoverageTab />
        </TabsContent>
        <TabsContent value="assignments" className="mt-6">
          <OfficialAssignmentsTab />
        </TabsContent>
        <TabsContent value="roster" className="mt-6">
          <OfficialRosterTab />
        </TabsContent>
        <TabsContent value="availability" className="mt-6">
          <AvailabilityTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EventManagementOfficials;
